import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetProjectSummary() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/summary",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetProject(projectId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/" + projectId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetProjects(start, limit, state, filters = {}) {
    const params = { start, limit, state };
    
    // Add any optional filters to params
    Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== null) {
            params[key] = filters[key];
        }
    });
    
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/",
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetProjectBillingEntities() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/billingEntities",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateProject(projectId, projectData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/project/" + projectId,
        data: projectData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetProjectExternalBoard(projectId, externalBoard) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/project/" + projectId + "/board",
        data: { externalBoard },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetProjectResponsible(projectId, responsible) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/project/" + projectId + "/responsible",
        data: { responsible },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetProjectAssignees(projectId, responsible, assignees) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/project/" + projectId + "/assignees",
        data: { responsible, assignees },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateProject(projectData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/project",
        data: projectData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateProjectStatus(projectId, status) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/project/" + projectId + "/status",
        data: { status },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCompleteProject(projectId, options) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/project/" + projectId + "/complete",
        data: options || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteProject(projectId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/project/" + projectId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRestoreProject(projectId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/project/" + projectId + "/restore",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetProjectMovePreview(projectId, accountId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/" + projectId + "/move/preview",
        params: { accountId },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestMoveProject(projectId, accountId) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/project/" + projectId + "/move",
        data: { accountId },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAuthorizeProject(projectId) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/project/" + projectId + "/authorize",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRejectProject(projectId) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/project/" + projectId + "/reject",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetUnansweredClientComments() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/unansweredClientComments",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetUnassignedSummary() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/unassigned/summary",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetUnassignedList(type = "project", cell = "", start = 0) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/unassigned/list",
        params: { type, cell, start },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetProjectsWithoutTasks(start = 0) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/noTasks/list",
        params: { start },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetMonthlyStatusBreakdown(months = 6) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/project/monthlyStatusBreakdown",
        params: { months },
        withCredentials: true,
        crossorigin: true,
    });
}